<template>
  <div>
    <v-container fluid pa-0>
      <div class="banner-wrap">
        <Banner class="pc-banner " :cat-code="-1" />
      </div>
      <ArticleHeader :item="article" />
      <div class="section_inner pa-3 pr-3 pr-lg-0">
        <ArticleBreadcrumbs :items="breadCrumbs" class="pr-0" />
        <v-row>
          <v-col cols="12" sm="12" md="9">
            <injector
              :content="article.content"
              class="display-22-16 article-content"
            >
              <template slot="q">
                <div>
                  <QuestionsPanel
                    :questions="article.questions"
                    :customHighlight="constants.QA"
                  />
                </div>
              </template>
            </injector>
          </v-col>
          <v-col cols="12" md="3" class="hidden-sm-and-down">
            <LeftPanel
              v-if="article.content"
              :article-length="article.content.length"
              :limit-side-banners="true"
            />
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-container fluid px-3 px-sd-0 px-md-0 mt-n8>
      <div class="section_inner">
        <CategoryArticles class="hidden-sm-and-down" :items="[extraArticles]" :showCategoryName="false"/>
        <ArticleGuideTips
          class="hidden-md-and-up mt-n6"
          :items="[extraArticles]"
        />

        <br />
      </div>
    </v-container>
  </div>
</template>


<script>
import ArticleHeader from '@/components/Article/ArticleHeader';
import ArticleGuideTips from '~/components/Articles/ArticleGuideTips';
import Banner from '@/components/Jobs_List/Banner';
import CategoryArticles from '~/components/Articles/CategoryArticles';
import injector from 'vue-html-injector/main.vue';
import LeftPanel from '@/components/LeftPanel';
import QuestionsPanel from '~/components/Article/QuestionsPanel';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import { ARTICLES, SEO, axiomLog } from '@/lib/api.js';

export default {
  name: 'articlePage',
  mixins: [SeoOptimization],
  components: {
    Banner,
    ArticleHeader,
    LeftPanel,
    injector,
    QuestionsPanel,
    CategoryArticles,
    ArticleGuideTips
  },

  data() {
    return {
      article: {},
      constants: t('titles.articles.lobby'),
      content: [],
      extraArticles: {},
      hotJobs: {},
      breadCrumbs: []
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },
  async asyncData({ error, route, $axios, redirect, $sentry, req }) {
    try {
      const {
        data: { data: data }
      } = await $axios.get(`${ARTICLES}${route.path}`);
      const {
        data: { data: seo }
      } = await $axios.get(`${SEO}${route.path}`);

      await axiomLog($axios, route.path, req, error);

      if (!data) {
        throw 'שגיאת מערכת ';
      }

      return {
        article: {
          title: data.title,
          content: data.script,
          link: data.link,
          text: data.text,
          date: data.date,
          readingTime: data.readingTime,
          questions: data.QA,
          videoSrc: data.videoSrc,
          author: data.author
        },
        extraArticles: data.articlesByCategory,
        breadCrumbs: [
          {
            name: 'Home page',
            value: 'דרושים',
            link: '/'
          },
          {
            name: 'lobby',
            value: 'מגזין קריירה',
            link: '/articles/'
          },
          {
            name: 'category',
            value: data.articlesByCategory?.name,
            link: `/articles/cat${data.articlesByCategory?.id}`
          },
          {
            name: 'article',
            value: data.title,
            link: `/article/${data.id}`
          }
        ],
        seodata: {
          articleSchemaScriptSeo: seo.articleSchemaScript,
          faqSchemaScriptSeo: seo.articleFaQSchemaScript,
          metaData: seo.metaDataItems,
          pageTitle: seo.title,
          breadCrumbsSchema: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'home',
                item: 'https://www.drushim.co.il/'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Articles lobby',
                item: 'https://www.drushim.co.il/articles/'
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: data.articlesByCategory?.name,
                item: `https://www.drushim.co.il/articles/cat${
                  data.articlesByCategory?.id
                }`
              },
              {
                '@type': 'ListItem',
                position: 4,
                name: data.title
              }
            ]
          }
        }
      };
    } catch (e) {
      $sentry.captureException('article error: ' + e);
      await axiomLog($axios, route.path, req, e);
    }
  },

  mounted() {
    window.scrollTo(0, 0);
  },
  head() {
    return {
      link: [
        {
          //canonical doesnt returned from api
          rel: 'canonical',
          href: 'https://www.drushim.co.il' + this.$route.fullPath
        }
      ],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.seodata.articleSchemaScriptSeo),
          type: 'application/ld+json'
        },
        {
          innerHTML: JSON.stringify(this.seodata.faqSchemaScriptSeo),
          type: 'application/ld+json'
        },
        {
          innerHTML: JSON.stringify(this.seodata.breadCrumbsSchema),
          type: 'application/ld+json'
        }
      ]
    };
  }
};
</script>



<style>
#salaryTable {
  width: 100%;
  margin: 0;
  border: none;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}
#salaryTable * {
  font-size: 15px !important;
}

#salaryTable td,
#salaryTable th {
  padding: 8px 3px;
  border-bottom: 10px solid #fff;
  text-align: center;
}

#salaryTable p {
  margin-bottom: 0;
}

#salaryTable td a {
  display: block;
  background: #3e4a54;
  padding: 1px 8px;
  border-radius: 15px;
  color: #fff;
  white-space: nowrap;
  font-size: 14px !important;
  width: fit-content;
  margin: 0 auto;
}

#salaryTable td {
  min-width: 110px;
  background: #f6f7f9;
}

#salaryTable th {
  position: relative;
  top: 0;
  z-index: 1;
  text-align: center;
}
#salaryTable th[scope='row'] {
  background: #f6f7f9;
}
#salaryTable th[scope='col'] {
  background: #f6f7f9;
}

html {
  scroll-behavior: unset;
}

.v-application p {
  margin-bottom: 0px !important;
}

b,
strong {
  font-weight: 500;
}
table {
  text-align: center;
}

.article-content table td {
  text-align: center;
}

/*** */

.salary-all div:nth-of-type(1) a {
  background: #ff7100 url('~assets/img/swirly-arrow.png') 20% 50% no-repeat;
  text-align: right !important;
  padding: 0 45px 0 0;
}
@media screen and (max-width: 600px) {
  #salaryTable td,
  #salaryTable th {
    border-bottom: 1px solid #fff;
  }

  .salary-all div:nth-of-type(1) a {
    background-size: 35px;
    padding: 0 15px 0 0;
    background-position: 10% 75%;
  }

  #salaryTable * {
    font-size: 13px !important;
  }
  #salaryTable td a {
    font-size: 12px !important;
  }
  .salaryBox #salaryTable {
    width: auto !important;
  }

  #salaryTable th[scope='row'] {
    background: #fff;
  }
  #salaryTable tr th:first-child {
    position: sticky;
    right: 0;
    z-index: 2;
    padding: 8px 10px;
  }
  #salaryTable tr th:first-child:after {
    content: '';
    border: 7px solid #fff;
    position: absolute;
    left: -3px;
    height: 100%;
    top: 0;
    box-shadow: -3px 0 2px #72727238;
  }
  .salaryBox {
    width: 100%;
    overflow: auto;
  }
  .salaryBox:focus {
    box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
    outline: 0;
  }
}
</style>
